<script setup lang="ts">
const props = defineProps<{
  ids: number[]
}>()
</script>

<template>
  <ApplicationContentAnnotationSlideover :ids="props.ids">
    <span
      class="
      group
      inline
      underline
      decoration-secondary-100/0
      decoration-0
      hover:decoration-4
      underline-offset-8
      hover:cursor-pointer
      hover:decoration-secondary-100
      dark:hover:decoration-neutral-700
      transition-all
    "
    >
      <span>
        <slot />
      </span>
      <ApplicationContentAnnotationIndicator
        v-for="id in props.ids"
        :id="id"
        :key="id"
      />
    </span>
  </ApplicationContentAnnotationSlideover>
</template>
